<template>
    
    <div class="swiper-container" id="KeyMomentSlider">

        <div class="swiper-wrapper">
            <slot></slot>
        </div>


        <div class="swiper-pagination" id="swiper-pagination" :class="{ lastslide: isLastSlide }">
            <div 
                v-for="(slide, index) in slides" 
                class="pagination-item"
                @click="gotoSlide(index)"
                :class="{ active: isActive(index) }"

                >
                <div class="bullet" :data-slide=index></div>
                <div class="white-bullet"></div>
                <div class="day">{{ slide.numero_de_journee | formatedDay }}</div>
            </div>
            <div id="progress-bar"></div>
        </div>
        
        <div class="control">
            <div>
                <div class="button-prev btn-prev">Jour précédent</div>
                <div></div>
                <div class="button-next btn-next">Jour suivant</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import $ from 'jquery';
    import Swiper from 'swiper';

    export default {
        props: {
            slides: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                swiperCruiseKeyMoment: null,
                activeSlide: 0,
                numbreOfSlide: 0
            };
        },
        computed:{
            isLastSlide(){
                if (this.activeSlide === this.numbreOfSlide-1){
                    return true
                }else{
                    return false
                }
            }
        },
        methods: {
            initSwiper(){

                // Init
                this.swiperCruiseKeyMoment = new Swiper ('#KeyMomentSlider',{
                    effect: "fade",
                    autoHeight: true,
                    threshold: 40,
                    speed: 300,
                    virtualTranslate: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '#KeyMomentSlider .button-next',
                        prevEl: '#KeyMomentSlider .button-prev',
                    }
                })

                this.numbreOfSlide = $('#KeyMomentSlider .swiper-slide').length

                // Events
                this.swiperCruiseKeyMoment.on('slideNextTransitionStart', ()=> {
                    this.majActiveSlide('next')

                });

                this.swiperCruiseKeyMoment.on('slidePrevTransitionStart', (el)=> {
                    this.majActiveSlide('prev')
                });

                this.swiperCruiseKeyMoment.on('slideChangeTransitionEnd', ()=> {
                    // Fermer la carte
                    $('#KeyMomentSlider .carte').removeClass('open')

                    // Rajout des classes next et prev pour que le CSS marche bien
                    $(this.swiperCruiseKeyMoment.slides).each((index, slide)=>{

                        if (index < this.swiperCruiseKeyMoment.activeIndex){
                            $(slide).addClass('swiper-slide-prev')
                        } else if (index > this.swiperCruiseKeyMoment.activeIndex) {
                            $(slide).addClass('swiper-slide-next')
                        }

                    })

                    this.clearPagination()
                });

                this.clearPagination()


            },
            clearPagination(){

                // Efface le bouton Suivant en fin de course
                if(this.swiperCruiseKeyMoment.activeIndex === (this.numbreOfSlide - 1)){
                    $('#KeyMomentSlider .button-next').addClass('disabled')
                }else{
                    $('#KeyMomentSlider .button-next').removeClass('disabled')
                }

                // Efface le bouton Précedent en début de course
                if(this.swiperCruiseKeyMoment.activeIndex === 0){
                    $('#KeyMomentSlider .button-prev').addClass('disabled')
                }else{
                    $('#KeyMomentSlider .button-prev').removeClass('disabled')
                }

            },
            swiperCarte(){
                $('#KeyMomentSlider .carte').on('click', function(){
                    $(this).toggleClass('open')
                })
            },
            gotoSlide(index){
                this.swiperCruiseKeyMoment.slideTo(index)
            },
            isActive(index){
                if(index <= this.activeSlide){
                    return true
                }else{
                    return false
                }
            },
            majProgressBar(){

                let y1 = $('#swiper-pagination').offset().left;
                let y2 = $('#swiper-pagination .bullet[data-slide="'+this.swiperCruiseKeyMoment.activeIndex+'"]').offset().left;

                let yDistance = y2 - y1;

                $('#progress-bar').width(yDistance)

            },
            majActiveSlide(direction){

                if (direction === 'next') {
                    setTimeout(()=>{
                        this.activeSlide = this.swiperCruiseKeyMoment.activeIndex
                    }, 500)
                } else {
                    this.activeSlide = this.swiperCruiseKeyMoment.activeIndex
                }

                this.majProgressBar()

            },

        },
        mounted() {
            this.initSwiper()
            this.swiperCarte()
            this.majProgressBar()


            $(window).bind('resizeEnd', () => {
                this.majProgressBar()
            });

        },
        created() {
            
        },
        destroyed() {
            
        },
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/cruise-product/KeyMomentSlider.vue